export default "__VITE_ASSET__Camns$iF__"